import { Component, OnInit, Directive } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../../services/auth/auth.service';
import { WindowService } from '../../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
//import { FormControl } from '@angular/forms/src/model';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, docChanges } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../../datamodel/user';
import { UploadService } from '../../../uploads/shared/upload.service';
import { Upload } from '../../../uploads/shared/upload';
import { ToggleService } from '../../../services/toggle/toggle.service';
import { StateService } from '../../../services/state/state.service';
import { Institution } from '../../../modules/datamodel/institution';
import { Provider } from '../../../modules/datamodel/provider';
import { Department } from '../../../modules/datamodel/department';
import * as _ from 'underscore';
import { MatDatepicker } from '@angular/material';
import { elementAt } from 'rxjs/operators/elementAt';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { forEach } from '@angular/router/src/utils/collection';
interface Shift {
    type: any;
}
interface ProviderShift {
    type: any;
}
interface Schedule {
    type: any;
}
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'key=AIzaSyBDB_jgKH-eDllQnGWTQJiRmQ2vSS0hKag'
    })
};
function mapSnapshot(changes: any) {
    return changes.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        return { id, ...data };
    });
}
@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss'],
    providers: [WindowService]
})
export class ScheduleComponent implements OnInit {

    tab = 1;
    setTab(newTab) {
        this.tab = newTab;
    };
    isSet = function (tabNum) {
        return this.tab === tabNum;
    };

    intab = 1;
    insetTab(innewTab) {
        this.intab = innewTab;
    };
    inisSet = function (intabNum) {
        return this.intab === intabNum;
    };

    activeId: string;
    public objSchedule: object;
    public objScheduleTags: Array<any>;
    public objShifts: Array<any>;
    public weekList: Array<any>;
    public shiftProvidersList = [];
    public listDoctors = [];
    public assignedDoctors = [];
    public showDoctorsListPopup:boolean = false;
    
    public selectedInstitution: object;

    public userProfile: object;
    private userRef: AngularFirestoreCollection<User>;
    obsUser: Observable<any>;

    private instituteRef: AngularFirestoreCollection<Institution>;
    obsInstitute: Observable<any>;
    private doctorsRef: AngularFirestoreCollection<Provider>;
    obsDoctors: Observable<any>;

    private scheduleRef: AngularFirestoreCollection<any>;
    obsSchedule: Observable<any>;
    private scheduleShiftRef: AngularFirestoreCollection<any>;
    obsScheduleShift: Observable<any>;
    private shiftProvidersRef: AngularFirestoreCollection<any>;
    obsShiftProviders: Observable<any>;

    private notificationsRef: AngularFirestoreCollection<any>;
    obsNotifications: Observable<any>;

    popoverTitle: string = 'Are you sure?';
    popoverMessage: string = 'Are you really <b>sure</b> you want to do this?';
    popoverAssignMessage: string = 'Are you really <b>sure</b> you want to assign the selected provider to this shift?';
    public confirmClicked: boolean = false;
    public cancelClicked: boolean = false;
    public placement: string = 'left';
    public selectedDoctorName: string = '';

    public objAvail: object;
    public selRow: string;
    public pval = "";
    public scheduleLogs = [];
    public schedulePendingLogs = [];
    public scheduleAcceptedLogs = [];
    public scheduleDeniedLogs = [];
    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, public toggle: ToggleService, private router: Router, public route: ActivatedRoute, private spinnerService: Ng4LoadingSpinnerService, public http: HttpClient) {
        
    }

    setDocname(fname, lname){
        this.selectedDoctorName = fname+' '+lname;
        // this.spinnerService.show();
        // setTimeout(() => {
        //     this.popoverAssignMessage = 'Are you really <b>sure</b> you want to assign ' + fname + ' ' + lname + ' to this shift?';
        //     this.spinnerService.hide();
        // }, 3000);
    }

    getUserProfile() {
        let objUser = firebase.auth().currentUser;
        this.userRef = this.afs.collection('users', ref => ref.where('email', '==', objUser.email));
        this.obsUser = this.userRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as User;
                const id = a.payload.doc.id;
                this.userProfile = { id: id, data: data };
                return { "id": id, "data": data };
            });
        });
        this.obsUser.subscribe(docs => {
            //console.log(docs[0].data.adminFor[0].name);
            this.getInstitute(docs[0].data.adminFor[0].name);
            this.getDoctorsList(docs[0].data.adminFor[0].id);
        });

    }

    getInstitute(hname) {
        this.instituteRef = this.afs.collection('institutions', ref => ref.where('name', '==', hname));
        this.obsInstitute = this.instituteRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as Institution;
                const id = a.payload.doc.id;
                this.selectedInstitution = { id: id, data: data };
                return { "id": id, "data": data };
            });
        });
        this.obsInstitute.subscribe(docs => {
            console.log(this.selectedInstitution);
            //this.getDoctorsList(docs[0].data.name);
        })
    }

    getDoctorsList(hid) {
        this.doctorsRef = this.afs.collection('providers', ref => ref.where('credentialedAt.' + hid + '.id', '==', hid));
        this.obsDoctors = this.doctorsRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as User;
                const id = a.payload.doc.id;
                //this.listDoctors.push({ id: id, data: data });
                return { id, ...data };
            });
        });
        this.obsDoctors.subscribe(docs => {
            this.listDoctors = docs;
        });
    }

    

    range(key, count) {
        var arr = [];
        for (let i = 0; i < count; i++) {
            arr.push(i);
        }
        return arr;
    }

    getScheduleDetails(pid) {
        let self = this;
        self.spinnerService.show();
        const document: AngularFirestoreDocument<any> = this.afs.doc('schedules/' + pid);
        const document$: Observable<any> = document.valueChanges();
        document$.subscribe(data => {
            this.objSchedule = data;
            if (data.tags && typeof data.tags !== "undefined" && data.tags !== null){
                this.objScheduleTags = data.tags;
            }else{
                this.objScheduleTags = [];
            }
            var objShifts = [];
            self.objShifts = [];
            self.scheduleShiftRef = self.afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', pid).orderBy('day','asc'));
            self.scheduleShiftRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
                for (let i in schedules) {
                    schedules[i].day = parseInt(schedules[i].day)%7;
                    //self.objShifts[schedules[i].day] = [];
                    if (schedules[i].provider && schedules[i].provider.id && schedules[i].provider.id!==""){
                        schedules[i].provider.ref.get().then(doc => {
                            let obDoc = doc.data();
                            schedules[i].provider = {
                                "id": schedules[i].provider.id,
                                "name": obDoc.first_name + ' ' + obDoc.last_name,
                                "photo": obDoc.photo !== "" ? obDoc.photo : "../assets/img/1.png"
                            };
                        });
                    }else{
                        schedules[i].provider = {
                            "id": "",
                            "name": "",
                            "photo": ""
                        };
                    }
                    //console.log(schedules[i]);
                    //self.objShifts.push(schedules[i]);
                    if (objShifts.length > 0 && objShifts[schedules[i].day] && objShifts[schedules[i].day] !== "undefined"){
                        //self.objShifts.push(objShifts[schedules[i].day]);
                    }else{
                        objShifts[schedules[i].day] = schedules[i];
                        self.objShifts.push(objShifts[schedules[i].day]);
                    }
                    self.spinnerService.hide();
                }
            });
            
            console.log(self.objShifts);
        });
    }

    getScheduleLogs(pid){
        let self = this;
        self.scheduleLogs = [];
        self.schedulePendingLogs = [];
        self.scheduleAcceptedLogs = [];
        self.scheduleDeniedLogs = [];
        let l = 1;
        let lp = 1;
        let la = 1;
        let ld = 1;
        self.shiftProvidersRef = self.afs.collection('provider_schedules', ref => ref.where('schedule.id', '==', pid).where('swap_request', '==', true).orderBy('day', 'asc'));
        self.shiftProvidersRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
            self.spinnerService.show();
            if (schedules && schedules.length > 0) {
                schedules.forEach(schedule => {
                    console.log(schedule);
                    // schedule.provider_ref.get().then(doc => {
                    //     if (doc.exists) {
                    //find the details from the notifications
                    self.notificationsRef = self.afs.collection('notifications', ref => ref.where('provider_schedule_id', '==', schedule.id));
                    self.notificationsRef.snapshotChanges().map(mapSnapshot).subscribe(notifications => {
                        console.log(notifications);
                        
                        if (notifications && notifications.length > 0) {
                            notifications.forEach(notification => {
                                self.scheduleLogs.push({
                                    iNum: l,
                                    shift_date: schedule.shift_date,
                                    type: notification.type,
                                    swap_status: notification.swap_status
                                });
                                l++;

                                if (notification.swap_status == "pending"){
                                    self.schedulePendingLogs.push({
                                        iNum: lp,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    lp++;
                                } else if (notification.swap_status == "accepted") {
                                    self.scheduleAcceptedLogs.push({
                                        iNum: la,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    la++;
                                } else if (notification.swap_status == "declined") {
                                    self.scheduleDeniedLogs.push({
                                        iNum: ld,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    ld++;
                                }
                            });
                        }
                    });
                    self.spinnerService.hide();
                });
            }else{
                self.spinnerService.hide();
            }
        });
    }

    dateFormat(dt) {
        dt = new Date(dt);
        let dfm = [
            dt.getFullYear(),
            ('0' + (dt.getMonth() + 1)).slice(-2),
            ('0' + dt.getDate()).slice(-2)
        ].join('-');
        return dfm;
    }

    CalculateWeekendDays(fromDate, toDate, weekDayKey) {
        if (weekDayKey > 6) {
            weekDayKey = weekDayKey % 7;
        }
        var start = new Date(fromDate);
        var finish = new Date(toDate);
        var dayMilliseconds = 1000 * 60 * 60 * 24;
        var weekendDays = 0;
        while (start.getTime() <= finish.getTime()) {
            var day = start.getDay();
            if (day == weekDayKey) {
                weekendDays++;
            }
            start = new Date(+start + dayMilliseconds);
        }
        return weekendDays;
    }

    assignDoctor(scheduleShiftId, l, doctor) {
        let self = this;
        let objUser = firebase.auth().currentUser;
        this.spinnerService.show();
        const userRef = this.afs.collection('users').doc(objUser.uid);
        userRef.valueChanges().subscribe(user => {
            //Get user hospital
            const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
                ? user['adminFor'][0].id : '';
            const userHospRef = self.afs.doc('institutions/' + userHospId);
            //get schedules of hospitals
            const sdocument: AngularFirestoreDocument<any> = self.afs.doc('schedules/' + self.activeId);
            const sdocument$: Observable<any> = sdocument.valueChanges();
            sdocument$.subscribe(schedule => {
                let promiseArr = [];
                let promise = new Promise(function (resolve, reject) {
                    const shiftDocument: AngularFirestoreDocument<any> = self.afs.doc('schedules_shifts/' + scheduleShiftId);
                    const shiftDocument$: Observable<any> = shiftDocument.valueChanges();
                    shiftDocument$.take(1).subscribe(scheduleShifts => {
                        console.log(scheduleShifts);
                        if (scheduleShifts) {
                            let objScheduleShift = scheduleShifts;
                            console.log(objScheduleShift);
                            let sdlRef = self.afs.doc('schedules_shifts/' + scheduleShiftId);
                            let docRefc = self.afs.doc('providers/' + doctor.id);
                            self.afs.collection('schedules_shifts').doc(scheduleShiftId).update({
                                provider: {
                                    id: doctor.id,
                                    ref: docRefc.ref
                                }
                            })
                            .then(function (val) {
                                self.shiftProvidersRef = self.afs.collection('provider_schedules', ref => ref.where('shift.id', '==', scheduleShiftId + ''));
                                self.shiftProvidersRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(pvdshifts => {
                                    console.log(pvdshifts);
                                    if (pvdshifts && pvdshifts.length > 0) {
                                        let count = 1;
                                        pvdshifts.forEach(pvdshift => {
                                            console.log(pvdshift);
                                            self.afs.collection("provider_schedules").doc(pvdshift.id).update({
                                                provider: {
                                                    id: doctor.id,
                                                    ref: docRefc.ref
                                                },
                                                modified: new Date()
                                            });
                                            count++;
                                        });
                                        if (count >= pvdshifts.length) {
                                            self.spinnerService.hide();
                                            self.getScheduleDetails(self.activeId);
                                            const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + userHospId);
                                            const idocument$: Observable<any> = idocument.valueChanges();
                                            idocument$.subscribe(hspdata => {
                                                var nTitle = "You have neen assigned a shift";
                                                var nMessage = hspdata.name + " has assigned a shift to " + doctor.first_name + " " + doctor.last_name + ".";
                                                if (doctor.device && doctor.device.deviceToken) {
                                                    let nmessage = {
                                                        "notification": {
                                                            "title": 'assign_shift',
                                                            "body": nMessage,
                                                            "sound": "default",
                                                            "click_action": "FCM_PLUGIN_ACTIVITY",
                                                            "icon": "fcm_push_icon"
                                                        },
                                                        "data": {
                                                            "param1": "value1",
                                                            "param2": "value2"
                                                        },
                                                        "to": doctor.device.deviceToken,
                                                        "priority": "high",
                                                        "restricted_package_name": ""
                                                    };
                                                    //console.log(nmessage);
                                                    self.http
                                                        .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                                        .subscribe(ntdata => {
                                                            //console.log(data);
                                                            //add notification collection
                                                            self.afs.collection('md_notifications').add({
                                                                created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                                                institute: {
                                                                    id: userHospId,
                                                                    ref: userHospRef.ref
                                                                },
                                                                provider: {},
                                                                type: 'assign_shift',
                                                                schedule: {
                                                                    id: self.activeId,
                                                                    ref: sdlRef.ref
                                                                },
                                                                recipient: {
                                                                    id: doctor.id,
                                                                    ref: docRefc.ref
                                                                },
                                                                message: { body: nMessage, title: nTitle },
                                                                status: '1'
                                                            });
                                                        });
                                                }
                                            });
                                        }
                                    }
                                });






                                /*self.createProviderSchedules(userHospId, self.activeId, scheduleShiftId, l, schedule.start_date, schedule.end_date, doctor.id).then((res) => {
                                    self.spinnerService.hide();
                                    self.getScheduleDetails(self.activeId);
                                    const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + userHospId);
                                    const idocument$: Observable<any> = idocument.valueChanges();
                                    idocument$.subscribe(hspdata => {
                                        var nTitle = "Shift update";
                                        var nMessage = hspdata.name + " has assigned a shift to " + doctor.first_name + " " + doctor.last_name + ".";
                                        if (doctor.device && doctor.device.deviceToken) {
                                            let nmessage = {
                                                "notification": {
                                                    "title": 'assign_shift',
                                                    "body": nMessage,
                                                    "sound": "default",
                                                    "click_action": "FCM_PLUGIN_ACTIVITY",
                                                    "icon": "fcm_push_icon"
                                                },
                                                "data": {
                                                    "param1": "value1",
                                                    "param2": "value2"
                                                },
                                                "to": doctor.device.deviceToken,
                                                "priority": "high",
                                                "restricted_package_name": ""
                                            };
                                            //console.log(nmessage);
                                            self.http
                                                .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                                .subscribe(ntdata => {
                                                    //console.log(data);
                                                    //add notification collection
                                                    self.afs.collection('md_notifications').add({
                                                        created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                                        institute: {
                                                            id: userHospId,
                                                            ref: userHospRef.ref
                                                        },
                                                        provider: {},
                                                        type: 'assign_shift',
                                                        schedule: {
                                                            id: self.activeId,
                                                            ref: sdlRef.ref
                                                        },
                                                        recipient: {
                                                            id: doctor.id,
                                                            ref: docRefc.ref
                                                        },
                                                        message: { body: nMessage, title: nTitle },
                                                        status: '1'
                                                    });
                                                });
                                        }
                                    });
                                });*/
                            });
                        } else {
                            self.spinnerService.hide();
                            reject('no shifts');
                        }
                    });
                });
            });
        });
        self.spinnerService.show();
        setTimeout(() => {
            //console.log("hide loader")
            self.spinnerService.hide();
        }, 6000);
    }

    createProviderSchedules(hospId, sdlId, sftId, wday, stdate, endate, docId) {
        console.log(hospId);
        var self = this;
        const hospDoc = self.afs.doc('institutions/' + hospId);
        //const docRef = self.afs.doc('providers/' + docId);
        var shiftReference = self.afs.doc('schedules_shifts/' + sftId);
        var sdlReference = self.afs.doc('schedules/' + sdlId);

        var tempR2 = 0;
        return new Promise(function (resolve, reject) {
            var providerRef: any;
            if (docId && docId !== '') {
                providerRef = self.afs.doc('providers/' + docId).ref;
            } else {
                providerRef = '';
            }

            var startDate = new Date(stdate);
            let orginalStartDate = new Date(stdate).getTime();
            let endDate = new Date(endate);
            let dayCount = self.CalculateWeekendDays(startDate, endDate, wday);
            var day2 = wday % 7;
            if (wday > 6) {
                var sday = (wday) - (startDate.getDay() || day2);
                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
            }
            else {
                var sday = (day2) - (startDate.getDay() || day2);
                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
            }

            var dLimit = Math.floor(dayCount / 2);

            for (let j = 0; j < dLimit; j++) {
                if (j > 0) {
                    loopStartDate.setDate(loopStartDate.getDate() + 14);
                }
                else {
                    loopStartDate.setDate(loopStartDate.getDate());
                }

                if (loopStartDate.getTime() >= orginalStartDate && loopStartDate.getDay() == day2) {
                    self.afs.collection('provider_schedules').add({
                        instituteRef: {
                            id: hospId,
                            ref: hospDoc.ref
                        },
                        schedule: {
                            id: sdlId,
                            ref: sdlReference.ref
                        },
                        shift: {
                            id: sftId,
                            ref: shiftReference.ref
                        },
                        provider: {
                            id: docId,
                            ref: providerRef
                        },
                        shift_date: loopStartDate,
                        shift_date_format: self.dateFormat(loopStartDate),
                        shift_timestamp: loopStartDate.getTime(),
                        day: loopStartDate.getDay(),
                        created: new Date()
                    });
                }
            }
            tempR2++;
            resolve(tempR2);
        });
    }

    addToProviderSchedule(schedule, scheduleShift, doc, wday){
        let self = this;
        var hospId = self.selectedInstitution['id'];
        var hospDoc = this.afs.doc('institutions/' + hospId);
        var sdlRef = this.afs.doc('schedules/' + self.activeId);
        const docRefc = self.afs.doc('providers/' + doc.id);
        var shiftDoc = this.afs.doc('schedules_shifts/' + scheduleShift.id);
        var count = 0;
        return new Promise(function (resolve, reject) {
            //console.log(data);
            let promiseArr = [];
            var startDate = new Date(schedule.start_date);
            let orginalStartDate = new Date(schedule.start_date).getTime();
            let endDate = new Date(schedule.end_date);
            let dayCount = self.CalculateWeekendDays(startDate, endDate, wday);
            var day2 = wday % 7;
            if (wday > 6) {
                var sday = (wday) - (startDate.getDay() || day2);
                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
            }
            else {
                var sday = (day2) - (startDate.getDay() || day2);
                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
            }

            var dLimit = Math.floor(dayCount / 2);
            for (let j = 0; j < dLimit; j++) {
                if (j > 0) {
                    loopStartDate.setDate(loopStartDate.getDate() + 14);
                }
                else {
                    loopStartDate.setDate(loopStartDate.getDate());
                }

                if (loopStartDate.getTime() >= orginalStartDate && loopStartDate.getDay() == day2) {
                    //console.log(self.dateFormat(loopStartDate));
                    let _promise = self.afs.collection('provider_schedules').add({
                        instituteRef: {
                            id: hospId,
                            ref: hospDoc.ref
                        },
                        schedule: {
                            id: self.activeId,
                            ref: sdlRef.ref
                        },
                        shift: {
                            id: scheduleShift.id,
                            ref: shiftDoc.ref
                        },
                        provider: {
                            id: doc.id,
                            ref: docRefc.ref
                        },
                        shift_date: new Date(loopStartDate),
                        shift_date_format: self.dateFormat(loopStartDate),
                        shift_timestamp: loopStartDate.getTime(),
                        day: loopStartDate.getDay(),
                        created: firebase.firestore.FieldValue.serverTimestamp()
                    });
                    //console.log("helloooooooo");
                    count++;
                    promiseArr.push(_promise);
                }
                if (j >= dLimit) {
                    resolve(j)
                }
            }

            return Promise.all(promiseArr).then(data => {
                resolve(data);
            })
            .catch(err => reject(err));
        });
    }


    removeDoctor(scheduleShiftId, l, pvdid) {
        console.log(scheduleShiftId);
        let self = this;
        let newPvdList = [];
        let count = 0;
        var hospId = self.selectedInstitution['id'];
        var hospRef = this.afs.doc('institutions/' + hospId);
        var sdlRef = this.afs.doc('schedules/' + self.activeId);
        self.spinnerService.show();
        const shiftDocument: AngularFirestoreDocument<any> = self.afs.doc('schedules_shifts/' + scheduleShiftId);
        const shiftDocument$: Observable<any> = shiftDocument.valueChanges();
        shiftDocument$.take(1).subscribe(scheduleShift => {
            if (scheduleShift) {
                var day = parseInt(scheduleShift.day) % 7;
                var shiftDoc = this.afs.doc('schedules_shifts/' + scheduleShiftId);
                self.afs.collection('schedules_shifts').doc(scheduleShiftId).update({
                    provider: {
                        id: '',
                        ref: ''
                    },
                    modified: new Date()
                }).then(function (val) {
                    self.shiftProvidersRef = self.afs.collection('provider_schedules', ref => ref.where('provider.id', '==', pvdid + '').where('shift.id', '==', scheduleShiftId + ''));
                    self.shiftProvidersRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(pvdshifts => {
                        console.log(pvdshifts);
                        if (pvdshifts && pvdshifts.length > 0) {
                            let count = 1;
                            pvdshifts.forEach(pvdshift => {
                                console.log(pvdshift);
                                self.afs.collection("provider_schedules").doc(pvdshift.id).update({
                                    provider: {
                                        id: '',
                                        ref: ''
                                    },
                                    modified: new Date()
                                });
                                count++;
                            });
                            if (count >= pvdshifts.length){
                                const docRefc = self.afs.doc('providers/' + pvdid);
                                const document: AngularFirestoreDocument<any> = self.afs.doc('providers/' + pvdid);
                                const document$: Observable<any> = document.valueChanges();
                                document$.take(1).subscribe(sdata => {
                                    //self.getScheduleDetails(self.activeId);
                                    let objUser = firebase.auth().currentUser;
                                    
                                    self.afs.collection("admin_logs").add({
                                        user_id: objUser.uid,
                                        provider: {
                                            id: pvdid,
                                            ref: docRefc.ref
                                        },
                                        content: 'Removed ' + sdata.first_name + ' ' + sdata.last_name + ' from schedule',
                                        type: 'remove_doctor_shift',
                                        data: { provider_id: pvdid, shift_id: scheduleShiftId, schedule_id: self.activeId },
                                        created: firebase.firestore.FieldValue.serverTimestamp()
                                    }).then(function (cres){
                                        self.spinnerService.hide();
                                        self.getScheduleDetails(self.activeId);
                                    });

                                    const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + hospId);
                                    const idocument$: Observable<any> = idocument.valueChanges();
                                    idocument$.take(1).subscribe(hspdata => {
                                        var nTitle = "Shift update";
                                        var nMessage = hspdata.name + ' has removed ' + sdata.first_name + ' ' + sdata.last_name + ' from shift.';
                                        if (sdata.device && sdata.device.deviceToken) {
                                            let nmessage = {
                                                "notification": {
                                                    "title": 'assign_shift',
                                                    "body": nMessage,
                                                    "sound": "default",
                                                    "click_action": "FCM_PLUGIN_ACTIVITY",
                                                    "icon": "fcm_push_icon"
                                                },
                                                "data": {
                                                    "param1": "value1",
                                                    "param2": "value2"
                                                },
                                                "to": sdata.device.deviceToken,
                                                "priority": "high",
                                                "restricted_package_name": ""
                                            };
                                            //console.log(nmessage);
                                            self.http
                                                .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                                .subscribe(ntdata => {
                                                    //console.log(data);
                                                    //add notification collection
                                                    self.afs.collection('md_notifications').add({
                                                        created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                                        institute: {
                                                            id: hospId,
                                                            ref: hospRef.ref
                                                        },
                                                        provider: {},
                                                        type: 'assign_shift',
                                                        schedule: {
                                                            id: self.activeId,
                                                            ref: sdlRef.ref
                                                        },
                                                        recipient: {
                                                            id: pvdid,
                                                            ref: docRefc.ref
                                                        },
                                                        message: { body: nMessage, title: nTitle },
                                                        status: true
                                                    });
                                                    self.spinnerService.hide();
                                                });
                                        }else{
                                            self.spinnerService.hide();
                                        }
                                    });
                                });
                            }
                        }
                    });
                });
            }
            
        });
        setTimeout(() => {
            console.log("hide loader")
            self.spinnerService.hide();
        }, 3000);
    }

    editSchedule() {
        this.router.navigate(['/edit-schedule/' + this.activeId]);
    }

    ngOnInit() {
        this.objAvail = {
            "am_only": "AM Only",
            "pm_only": "PM Only",
            "full_day": "Full Day",
            "full_time": "Full Time",
            "emergency_only": "Emergency",
            "NA": "Not Available"
        };
        this.route.params.subscribe(p => {
            if (p.id) {
                this.activeId = p.id;
                this.getScheduleDetails(this.activeId);
                this.getScheduleLogs(this.activeId);
            }
        });

        this.weekList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.getUserProfile();
    }

    assignDoctorOldMethod(l, doc) {
        let self = this;
        let objUser = firebase.auth().currentUser;
        var hospId = self.selectedInstitution['id'];
        var hospDoc = this.afs.doc('institutions/' + hospId);
        var sdlRef = this.afs.doc('schedules/' + self.activeId);
        const docRefc = self.afs.doc('providers/' + doc.id);
        var result = [];
        var count = 0;
        this.spinnerService.show();
        const userRef = this.afs.collection('users').doc(objUser.uid);
        userRef.valueChanges().subscribe(user => {
            //Get user hospital
            const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
                ? user['adminFor'][0].id : '';

            //get schedules of hospitals
            const sdocument: AngularFirestoreDocument<any> = self.afs.doc('schedules/' + self.activeId);
            const sdocument$: Observable<any> = sdocument.valueChanges();
            sdocument$.subscribe(schedule => {
                let promiseArr = [];
                let promise = new Promise(function (resolve, reject) {
                    self.scheduleShiftRef = self.afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', self.activeId));
                    self.scheduleShiftRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(scheduleShifts => {
                        if (scheduleShifts && scheduleShifts.length > 0) {
                            let _scheduleShifts2 = [];
                            scheduleShifts.forEach(function (scheduleShift) {
                                var day = parseInt(scheduleShift.day) % 7;
                                if (l == day) {
                                    scheduleShift['schedule'] = schedule;
                                    _scheduleShifts2.push(scheduleShift);
                                }
                            });
                            resolve(_scheduleShifts2);
                        } else {
                            //self.spinnerService.hide();
                            reject('no shifts');
                        }
                    });
                });
                promiseArr.push(promise);

                if (promiseArr.length > 0) {
                    Promise.all(promiseArr)
                        .then(scheduleShifts => {
                            let _scheduleShifts = [];
                            if (scheduleShifts && scheduleShifts.length > 0) {
                                scheduleShifts.forEach(scheduleShift => {
                                    _scheduleShifts = _scheduleShifts.concat(scheduleShift);
                                });
                            }
                            let promiseArr2 = [];
                            if (_scheduleShifts && _scheduleShifts.length > 0) {
                                var t = 0;
                                _scheduleShifts.forEach(_scheduleShift => {
                                    //console.log(_scheduleShift);
                                    self.afs.collection('schedules_shifts').doc(_scheduleShift.id).update({
                                        provider: {
                                            id: doc.id,
                                            ref: docRefc.ref
                                        }
                                    })
                                        .then(function (val) {
                                            count++;
                                            var sday = parseInt(_scheduleShift.day) % 7;
                                            //save data into provider schedules for selected day
                                            self.addToProviderSchedule(schedule, _scheduleShift, doc, _scheduleShift.day)
                                                .then((pdres) => {
                                                    console.log(pdres);
                                                    //self.spinnerService.hide();
                                                    self.getScheduleDetails(self.activeId);

                                                    const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + hospId);
                                                    const idocument$: Observable<any> = idocument.valueChanges();
                                                    idocument$.subscribe(hspdata => {
                                                        var nTitle = "You have been assigned a shift";
                                                        var nMessage = hspdata.name + " has assigned a shift to " + doc.first_name + " " + doc.last_name + ".";
                                                        if (doc.device && doc.device.deviceToken) {
                                                            let nmessage = {
                                                                "notification": {
                                                                    "title": 'assign_shift',
                                                                    "body": nMessage,
                                                                    "sound": "default",
                                                                    "click_action": "FCM_PLUGIN_ACTIVITY",
                                                                    "icon": "fcm_push_icon"
                                                                },
                                                                "data": {
                                                                    "param1": "value1",
                                                                    "param2": "value2"
                                                                },
                                                                "to": doc.device.deviceToken,
                                                                "priority": "high",
                                                                "restricted_package_name": ""
                                                            };
                                                            //console.log(nmessage);
                                                            self.http
                                                                .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                                                .subscribe(ntdata => {
                                                                    //console.log(data);
                                                                    //add notification collection
                                                                    self.afs.collection('md_notifications').add({
                                                                        created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                                                        institute: {
                                                                            id: hospId,
                                                                            ref: hospDoc.ref
                                                                        },
                                                                        provider: {},
                                                                        type: 'assign_shift',
                                                                        schedule: {
                                                                            id: self.activeId,
                                                                            ref: sdlRef.ref
                                                                        },
                                                                        recipient: {
                                                                            id: doc.id,
                                                                            ref: docRefc.ref
                                                                        },
                                                                        message: { body: nMessage, title: nTitle },
                                                                        status: '1'
                                                                    });
                                                                });
                                                        }
                                                    });
                                                });
                                        });

                                });

                                //self.router.navigate(['/schedule/' + self.activeId]);
                                return Promise.resolve();
                            }
                        });
                }
            });
        });
        self.spinnerService.show();
        setTimeout(() => {
            //console.log("hide loader")
            self.spinnerService.hide();
        }, 6000);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/schedules/schedule/schedule.component.ts